<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h10"><span class="th10">Dedication</span></h1>
<p class="p1">For my beautiful daughters who make my life worthwhile. And my parents who support me no matter what.</p>
<p class="p1"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?33331bc0